module.exports = __webpack_public_path__ + "img/GCC.fd7cfc7e.jpg";